import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import authReducer from './reducers/authReducer';
import driverPartnerReducer from './reducers/driverPartnerReducer';
import notificationReducer from './reducers/notificationReducer';
import supportReducer from './reducers/supportReducer';
import driverReducer from './reducers/driverReducer';
import faqReducer from './reducers/faqReducer';
import helpTopicReducer from './reducers/helpTopicReducer';
import policyReducer from './reducers/policyReducer';
import resourcesReducer from './reducers/resourceReducer';

// Combine reducers if there are multiple reducers
const rootReducer = combineReducers({
  auth: authReducer,
  driverPartner:driverPartnerReducer,
  notifications: notificationReducer,
  support: supportReducer,
  driver: driverReducer,
  faq: faqReducer,
  helpTopic: helpTopicReducer,
  policy: policyReducer,
  resources: resourcesReducer,

});


// Create Redux store with middleware
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
